"use client";
import { useState } from "react";
import Link from "next/link";
import { signOut } from "next-auth/react";
import { usePathname } from "next/navigation";
import { useRouter } from "next/navigation";
const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const path = usePathname();
  const router = useRouter();
  const handleLogout = async () => {
    await signOut({ redirect: false });
    router.push("/login");
  };
  return (
    <div className="flex h-full">
      {/* Sidebar */}
      <div
        className={`bg-gray-800 text-white h-screen p-5 pt-8 ${
          isOpen ? "w-64" : "w-16"
        } duration-300 relative`}
      >
        <button
          className="absolute top-4 right-4 text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          {/* {isOpen ? "❌" : "☰"} */}
        </button>
        <h1 className={`text-2xl font-bold mb-8 ${!isOpen && "hidden"}`}>
          Admin
        </h1>
        <ul className="space-y-4">
          <li
            className={`${
              path == "/acronis" ? "bg-[#cf0fff] text-white font-bold" : ""
            } rounded-2xl p-4 flex flex-row gap-4`}
          >
            <svg
              className="w-6 h-6 text-white "
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 13v-2a1 1 0 0 0-1-1h-.757l-.707-1.707.535-.536a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-.536.535L14 4.757V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.757l-1.707.707-.536-.535a1 1 0 0 0-1.414 0L4.929 6.343a1 1 0 0 0 0 1.414l.536.536L4.757 10H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.757l.707 1.707-.535.536a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.536-.535 1.707.707V20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.757l1.707-.708.536.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-.535-.536.707-1.707H20a1 1 0 0 0 1-1Z"
              />
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
              />
            </svg>

            <Link href="/acronis">
              <span className={`hover:text-gray-300  `}>Acronis API Key</span>
            </Link>
          </li>
          <li className="hover:bg-[#cf0fff] text-white font-bold cursor-pointer rounded-2xl p-4 flex flex-row gap-4">
            <svg
              className="w-6 h-6 text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 12H4m12 0-4 4m4-4-4-4m3-4h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2"
              />
            </svg>

            <button onClick={handleLogout}>
              <span className="hover:text-gray-300">Logout</span>
            </button>
          </li>
        </ul>
      </div>

      <div className="flex-1 p-7">{children}</div>
    </div>
  );
};

export default Sidebar;
